import React from 'react';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import { FaChartLine } from 'react-icons/fa';
import { LuChartSpline } from "react-icons/lu";

const ChatInterface = ({ 
  isSidebarVisible, 
  hasStartedChat, 
  messages, 
  botMessageHeight, 
  messagesEndRef, 
  botMessageRef, 
  handleModelDiagnostics, 
  handleInterpretResults, 
  isSending, 
  downloadPlot,
  input,
  setInput,
  handleSend,
  waitingForOutcome,
  selectedImages,
  imagePreview,
  removeImage,
  fileInputRef,
  fileUploadRef,
  handleFileSelect,
  handleImageSelect,
  handleFileUpload
}) => {
  return (
    <div className={`chat-interface${isSidebarVisible ? " sidebar-expanded" : ""}`}>
      {/* Welcome Section - only show when chat hasn't started */}
      {!hasStartedChat && (
        <div className="welcome-section">
          <div className="welcome-content">

            <h1 className="welcome-title">Hey, I'm Priori.</h1>
            <p className="welcome-subtitle">
              I can help you analyze your data, build models, and much more...
            </p>
          </div>
          
          {/* Analysis Workflows Section */}
          <div className="workflows-section">
            <div className="workflows-header">
              <h3>Popular workflows</h3>
              <a href="#" className="all-workflows-link">View all workflows →</a>
            </div>
            <div className="workflows-grid">
              <div className="workflow-card" onClick={() => setInput("Upload my dataset and run exploratory data analysis")}>
                <div className="workflow-icon data-analysis">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z" fill="#7F55B1"/>
                  </svg>
                </div>
                <div className="workflow-content">
                  <h4>Data Analysis</h4>
                  <p>Upload your dataset and get comprehensive statistical summaries, distributions, and insights.</p>
                </div>
              </div>
              
              <div className="workflow-card" onClick={() => setInput("Build a predictive regression model")}>
                <div className="workflow-icon regression-modeling">
                  <LuChartSpline size={24} color="#2F5249" />
                </div>
                <div className="workflow-content">
                  <h4>Regression Modeling</h4>
                  <p>Build linear or logistic regression models with automatic feature selection and validation.</p>
                </div>
              </div>
              
              <div className="workflow-card" onClick={() => setInput("Build a time series forecasting model")}>
                <div className="workflow-icon time-series-forecasting">
                  <FaChartLine size={24} color="#0C7489" />
                </div>
                <div className="workflow-content">
                  <h4>Time Series Forecasting</h4>
                  <p>Analyze trends and seasonality to forecast future values from time-dependent data.</p>
                </div>
              </div>
              
              <div className="workflow-card" onClick={() => setInput("Help me create a custom workflow")}>
                <div className="workflow-icon create-workflows">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#fff"/>
                  </svg>
                </div>
                <div className="workflow-content">
                  <h4>Create Workflow</h4>
                  <p>Build custom analysis workflows tailored to your specific data science needs and requirements.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Chat Messages - only show when chat has started */}
      {hasStartedChat && (
        <ChatMessages 
          messages={messages}
          isSidebarVisible={isSidebarVisible}
          hasStartedChat={hasStartedChat}
          botMessageHeight={botMessageHeight}
          messagesEndRef={messagesEndRef}
          botMessageRef={botMessageRef}
          handleModelDiagnostics={handleModelDiagnostics}
          handleInterpretResults={handleInterpretResults}
          isSending={isSending}
          downloadPlot={downloadPlot}
        />
      )}

      {/* Chat Input - always show */}
      <ChatInput 
        input={input}
        setInput={setInput}
        handleSend={handleSend}
        isSending={isSending}
        hasStartedChat={hasStartedChat}
        waitingForOutcome={waitingForOutcome}
        selectedImages={selectedImages}
        imagePreview={imagePreview}
        removeImage={removeImage}
        fileInputRef={fileInputRef}
        fileUploadRef={fileUploadRef}
        handleFileSelect={handleFileSelect}
        handleImageSelect={handleImageSelect}
        handleFileUpload={handleFileUpload}
        isSidebarVisible={isSidebarVisible}
      />
    </div>
  );
};

export default ChatInterface;
